import React, { useState, useEffect, useContext, useRef } from 'react';
import { MapaAlertas } from '../../components/pages/incidentes/MapaAlertas';
import { ContenedorParametros } from '../../components/utils/ContenedorParametros';
import { SocketContext } from '../../../context/provider/SocketProvider';
import { capitalizarTexto, classNameInput, formatearFechaHora, notify, primeraLetraMayuscula } from '../../../utils/utils';
import { GoogleMap } from '../../../utils/googlemaps';
import { Modal } from '../../components/modal/Modal';
import { useModal } from '../../../hooks/useModal';
import { AuthFetch } from '../../../services/api';
import icono from '../../../assets/images/logo192.png'
import iconoPolicia from '../../../assets/images/iconoPolicia.png'
import { Tooltip } from '../../components/utils/Tooltip';
import ReactTooltip from 'react-tooltip';
import { useSeguimientoAlertas } from '../../../hooks/Incidentes/useSeguimientoAlertas';
import { useCalificacionAlerta } from '../../../hooks/Incidentes/useCalificacionAlerta';
import '../../../assets/css/components/googleMapsTest.css'
import botonAlertasCercanas from '../../../assets/images/botones-mapa-incidencias/BtnPlaminMapaVerGrupo.png'
import botonAgentesActivos from '../../../assets/images/botones-mapa-incidencias/BtnPlaminMapaVerAgente.png'
import botonCamarasDisponibles from '../../../assets/images/botones-mapa-incidencias/BtnPlaminMapaVerCamaras.png'
import botonVerMapa from '../../../assets/images/botones-mapa-incidencias/BtnPlaminMapaVerMapa.png'
import camaraSinConexion from '../../../assets/images/camara-sin-señal.gif'

import { ModalAsignacion } from '../../components/modal/ModalAsignacion';
import { useIncidentes } from '../../../hooks/Incidentes/useIncidentes';
import { ComponenteCarga } from '../../components/forms/ComponenteCarga';
import { useSound } from '../../../context/provider/SoundProvider';
import { createRoot } from 'react-dom/client';
import { UserContext } from '../../../context/provider/UserProvider';
import iconBus from '../../../assets/images/icon-alert-bus.png'
import iconoComisaria from '../../../assets/images/IcoUbicacionComisaria04.png';
import { useWebsocket } from '../../../context/provider/WebsocketProvider';

const google = window.google;
const googleMap = new GoogleMap();
const urlBasePlamin = process.env.REACT_APP_PLAMIN_API + "/api";
// const URL = 'http://localhost:5240/api'

const useFotos = () => {
    const [ fotoUrl, setFotoUrl ] = useState();
    const [ isOpenFoto, openModalFoto, closeModalFoto ] = useModal(false); 

    const verFoto = (nomCarpeta,nombreFoto) => {
        setFotoUrl(url =>`https://minio.api.abexacloud.com/api/Archivo/verImagen?NombreCarpeta=${nomCarpeta}&NombreImagen=${nombreFoto}`);
        openModalFoto();
    }
    return [ fotoUrl, verFoto, isOpenFoto, closeModalFoto ] 
}

export const Incidentes = () => {
    const audioAlerta = useRef(null);
    const eventoMostrarAgentesRef = useRef(null)
    const eventoAgenteAsignadoRef = useRef(null)
    const marcadoresAgentesRef = useRef([])
    const marcadorCamaraRef = useRef(null)
    const incidenteActualRef = useRef({})

    const {stateSocket, clearPayload} = useContext(SocketContext);
    const {sonidoAlertaActual} = useSound()

    const hookIncidentes = useIncidentes()
    const hookSeguimientoAlertas = useSeguimientoAlertas()
    const hookCalificacionAlerta = useCalificacionAlerta()
    const [isOpenModalAgentes, openModalAgentes, closeModalAgentes] = useModal();
    const [fotoUrl, verFoto, isOpenFoto, closeModalFoto] = useFotos();
    const [isOpenModalCamara,openModalCamara,closeModalCamara] = useModal()

    const [incidenteActual, setIncidenteActual] = useState({})
    const [verAgentes, setVerAgentes] = useState(false)
    const [verAgenteAsignado, setVerAgenteAsignado] = useState(false)
    const [usuarioPosteo, setUsuarioPosteo] = useState()
    const [mostrarEfectoOndas, setMostrarEfectoOndas] = useState(false)
    const [waveRadius, setWaveRadius] = useState(200);
    const [isDragging, setIsDragging] = useState(false);
    const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
    const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
    const [rotacion, setRotacion] = useState(0);
    const [zoom, setZoom] = useState(1);
    const [marcadoresCercanos, setMarcadoresCercanos] = useState([])
    const [marcadoresCercanosReferencias, setMarcadoresCercanosReferencias] = useState([])
    const [verMarcadoresCercanos, setVerMarcadoresCercanos] = useState(false)
    const [verPuntosDeReferencia,setVerPuntosDeReferencia] = useState(false)
    const [verCamaras,setVerCamaras] = useState(false)
    const [estaCargando, setEstaCargando] = useState(false)
    const [ubicacionesAgentes,setUbicacionesAgentes] = useState([])
    const [trackingTopic, setTrackingTopic] = useState(null);
    const [recorridoUnidad, setRecorridoUnidad] = useState([]);
    const polilineaRecorridoRef = useRef(null);
    const infowindowRef = useRef(new google.maps.InfoWindow());
    const codEntidad = localStorage.getItem('codEntidad');
    const { stateUser } = useContext(UserContext)
    const empresaUnidadRef = useRef('')
    const arrayEmpresasAlertasPermitidas = [5,6,8,11,14,15,16,20,22,26,32,34,44,45,47,48,54,57,58,59,60,63,64,65,66,67,69,70,71,72,73,74]
    const [isOpenComisariaDetalle, openModalComisariaDetalle, closeModalComisariaDetalle] = useModal()
    const [comisariaDetalle, setComisariaDetalle] = useState({})
    const poligonosAlertas = useRef([])
    const marcadoresComisariasAlertas = useRef([])
    const poligonosTrackingRef = useRef([])
    const marcadorComisariaTrackingRef = useRef(null)
    const { socket, isConnected } = useWebsocket()
    const suscripcionActualRef = useRef(null)
    const datosUnidadSeguimientoRef = useRef({
        padron: '',
        placa: '',
        conductor: ''
    })
    

    const convertirMultiPoligonoACoordenadas = (lineasPoligonales) => {
        if (!lineasPoligonales) return [];
        const polygonMatch = lineasPoligonales.match(/\([^()]*\)/g)
        if (!polygonMatch) return [];

        return polygonMatch.map(polyStr => {
            const coordenadas = polyStr.replace(/[()]/g, '').trim().split(',')
            return coordenadas.map(coord => {
                const [lng, lat] = coord.trim().split(/\s+/)
                return { lat: Number(lat), lng: Number(lng) }
            });
        });
    };

    const limpiarAlertasAnteriores = (uidSeleccionado, marcadorSeleccionado) => {
        if (marcadorSeleccionado) { hookIncidentes.stateIncidentes.googleMap.quitarTodosLosMarcadoresExcepto([marcadorSeleccionado, hookIncidentes.marcadorGifAlerta.current]) }

        poligonosAlertas.current = poligonosAlertas.current.filter(item => { // eliminar jurisdicciones de otras alertas
            if (item.uidAlerta !== uidSeleccionado) {
                item.poligonos.forEach(poligono => poligono.setMap(null));
                return false;
            }
            return true;
        });

        marcadoresComisariasAlertas.current = marcadoresComisariasAlertas.current.filter(item => {  // eliminar comisarias de otras alertas
            if (item.uidAlerta !== uidSeleccionado) {
                if (item.marcador) item.marcador.setMap(null);
                return false;
            } else {
                if (item.marcador) { // restauramos marcador de la alerta activa
                    item.marcador.setMap(hookIncidentes.stateIncidentes.googleMap.map);
                }
                return true;
            }
        });
        setMostrarEfectoOndas(false);
        if(hookIncidentes.stateIncidentes.googleMap.circulos){
            hookIncidentes.stateIncidentes.googleMap.circulos.map(data => data.setMap(null));
        }

    };

    const limpiarSeguimientoVehiculo = () => {
        if (suscripcionActualRef.current) { // limpiamos la susciption activa para que se suscriba la nueva 
            console.log("Desconectando de la unidad anterior:", suscripcionActualRef.current)
            socket.emit('leaveUnidad', suscripcionActualRef.current, (respuesta) => {
                console.log(`[${new Date().toLocaleTimeString()}] Respuesta leaveUnidad interna:`, respuesta);
            });
            suscripcionActualRef.current = null; // limpiamos la referencia
        }
        setTrackingTopic(null); // detiene la suscripcion MQTT de la unidad anterior
        setRecorridoUnidad([]); // limpia el arreglo de coordenadas
        polilineaRecorridoRef.current = null; // limpia la referencia de la linea
        if (hookIncidentes.stateIncidentes.googleMap) {
            hookIncidentes.stateIncidentes.googleMap.quitarTodosLasPolilineas(); // borra la linea azul del mapa
        }
        if (hookIncidentes.marcadorUnidad.current) {
            hookIncidentes.marcadorUnidad.current.setOptions({ visible: false }); // oculta el icono del bus
        }
        limpiarJurisdiccionTracking();
    };

    const cargarJurisdiccionYComisaria = async (latitud, longitud, uidAlerta = null, esTracking = false) => {
        try {
            if (esTracking) { limpiarJurisdiccionTracking() }

            const response = await AuthFetch({
                url: urlBasePlamin + '/Entities/jurisdictionByAlert?' + new URLSearchParams({
                    latitud: latitud,
                    longitud: longitud
                })
            });

            if (response.isValid && response.content) {
                const { jurisdiccion, comisaria } = response.content;
                if (jurisdiccion && jurisdiccion.lineasPoligonales) { // dibujamos el poligono
                    const arreglosCoordenadas = convertirMultiPoligonoACoordenadas(jurisdiccion.lineasPoligonales);
                    const nuevasInstancias = [];
                    
                    arreglosCoordenadas.forEach(path => {
                        const poligono = new window.google.maps.Polygon({
                            paths: path,
                            strokeColor: jurisdiccion.color || "#0000FF",
                            strokeOpacity: 0.8,
                            strokeWeight: 2,
                            fillColor: jurisdiccion.color || "#0000FF",
                            fillOpacity: 0.2,
                            zIndex: 1,
                            map: hookIncidentes.stateIncidentes.googleMap.map
                        });
                        nuevasInstancias.push(poligono);
                    });
                    if (esTracking) {
                        poligonosTrackingRef.current = nuevasInstancias;
                    } else {
                        poligonosAlertas.current.push({
                            uidAlerta: uidAlerta,
                            codAlerta: incidenteActualRef.current.codAlerta,
                            poligonos: nuevasInstancias
                        });
                    }
                }

                if (comisaria) {  // dibujar marcador de comisaria
                    let nuevoMarcadorComisaria = null;
                    if (comisaria.latitudComisaria && comisaria.longitudComisaria) {
                        nuevoMarcadorComisaria  = hookIncidentes.stateIncidentes.googleMap.crearMarcador({
                            latLng: { lat: comisaria.latitudComisaria, lng: comisaria.longitudComisaria },
                            icon: iconoComisaria,
                            animation: null
                        });
                    }
                    nuevoMarcadorComisaria.addListener('click', () => { 
                        setComisariaDetalle(comisaria)
                        openModalComisariaDetalle()
                    })
                    if (esTracking) {
                        marcadorComisariaTrackingRef.current = nuevoMarcadorComisaria;
                    } else {
                        marcadoresComisariasAlertas.current.push({
                            uidAlerta: uidAlerta,
                            codAlerta: incidenteActualRef.current.codAlerta,
                            marcador: nuevoMarcadorComisaria
                        });
                    }
                }
            } else {
                notify("Esta alerta no pertenece a ninguna jurisdicción mapeada", "warning");
            }
        } catch (error) {
            console.error("Error al obtener jurisdicción de la alerta:", error);
        }
    };

    const limpiarJurisdiccionTracking = () => {
        poligonosTrackingRef.current.forEach(poligono => poligono.setMap(null));
        poligonosTrackingRef.current = [];

        if (marcadorComisariaTrackingRef.current) {
            marcadorComisariaTrackingRef.current.setMap(null);
            marcadorComisariaTrackingRef.current = null;
        }
    };

    useEffect(() =>{
        (async () => {
            setEstaCargando(true)
            await hookIncidentes.obtenerJurisdiccionPoligono()
            await hookIncidentes.listarIncidentes()
            setEstaCargando(false)
        })()
    },[])

    useEffect(() => {
        incidenteActualRef.current = incidenteActual
    },[incidenteActual])
    
    useEffect(() => {
        if(verAgenteAsignado){
            eventoAgenteAsignadoRef.current = setInterval(() => {
                mostrarUbicacionAgente(usuarioPosteo,false)
            }, 5000)
        }else{
            clearInterval(eventoAgenteAsignadoRef.current)
        }

        return () => {
            clearInterval(eventoAgenteAsignadoRef.current)
        }
    }, [verAgenteAsignado])

    useEffect(() => {
        if(Object.keys(hookIncidentes.positionNuevaIncidencia).length != 0){
            setMostrarEfectoOndas(true)
        }else{
            setMostrarEfectoOndas(false)
        }
    },[hookIncidentes.positionNuevaIncidencia])

    useEffect(() => {
        if(mostrarEfectoOndas){
            const timer = setInterval(() => {
                setMostrarEfectoOndas(false)
            },5000)
            
            const interval = setInterval(() => {
                if(mostrarEfectoOndas){
                    setWaveRadius((prevRadius) => (prevRadius + 50) % 300);
                }
            }, 200);
            
            if(!mostrarEfectoOndas){    //limpia el timer cuando mostrarefectoondas es false
                clearInterval(interval)
                hookIncidentes.stateIncidentes.googleMap.circulos.map((data,i) => {
                    data.setMap(null)
                })
            }
            return () => {
                clearInterval(timer)
                clearInterval(interval)
            }
        }
    }, [mostrarEfectoOndas]);

    useEffect(() => {
        if(mostrarEfectoOndas){
            hookIncidentes.stateIncidentes.googleMap.circulos.map((data,i) => {    //elimina todos los circulos
                data.setMap(null)
            })
    
            hookIncidentes.stateIncidentes?.googleMap.crearCirculo({
                latLng: {
                    lat:Number(hookIncidentes.positionNuevaIncidencia?.lat),
                    lng:Number(hookIncidentes.positionNuevaIncidencia?.lng)
                },
                radio: waveRadius,
                color: '#FF0000',
                opacidadBorde: 1,
                anchoBorde: 1,
                opacidadFondo: 0,
                colorFondo: ''
            })
        }
    },[mostrarEfectoOndas,waveRadius])

    useEffect(() => {
        if(verMarcadoresCercanos){
            const arrayMarcadores = 
            marcadoresCercanos.map((data) => {
                return hookIncidentes.stateIncidentes.googleMap.crearMarcador({
                    latLng: {lat: Number(data.latitudRegistro), lng: Number(data.longitudRegistro)},
                    icon: {
                        url: '/marcador-verde-2.png',
                        scaledSize: new google.maps.Size(30, 40), // Tamaño del marcador
                        labelOrigin: {
                            x: 15,
                            y: -10
                        }
                    },
                    label: {
                        text: data.codAlerta.toString(), // Texto encima del marcador
                        color: 'black', // Color del texto
                        fontSize: '16px', // Tamaño del texto
                        fontWeight: 'bold', // Opcional: estilo de texto
                    },
                })
            })
            setMarcadoresCercanosReferencias(arrayMarcadores)
        }else{
            marcadoresCercanosReferencias.forEach(data => {
                hookIncidentes.stateIncidentes.googleMap.quitarMarcadorEspecifico(data)
            })
            setMarcadoresCercanosReferencias([])
        }
    }, [verMarcadoresCercanos])

    useEffect(() => {
        const limpiarEfecto = () => {
            clearInterval(eventoMostrarAgentesRef.current)
            eventoMostrarAgentesRef.current = null
            marcadoresAgentesRef.current.forEach(data => hookIncidentes.stateIncidentes.googleMap.quitarMarcadorEspecifico(data))    // QUITA TODOS LOS MARCADORES DE AGENTES
            marcadoresAgentesRef.current = []
        }
        hookIncidentes.stateIncidentes.googleMap.infoWindow && hookIncidentes.stateIncidentes.googleMap.infoWindow.close()  // ELIMINA EL INFOWINDOW SI ESTABA ABIERTO
        if(verAgentes){
            eventoMostrarAgentesRef.current = setInterval(() => {
                crearMarcadoresAgentes(incidenteActualRef.current.codAlerta || null)
            }, (7000));
        }else{
            limpiarEfecto()
        }
        return() => {
            limpiarEfecto()
        }
    },[verAgentes])

    useEffect(() => {
        const ocultarPOI = [
            {
                featureType: "poi",
                stylers: [{ visibility: "off" }]
            }
        ];
        const mostrarPOI = [
            {
                featureType: "poi",
                stylers: [{ visibility: "on" }]
            }
        ];
        if(hookIncidentes.stateIncidentes.googleMap.map){
            hookIncidentes.stateIncidentes.googleMap.map.setOptions({
                styles: verPuntosDeReferencia ? ocultarPOI : mostrarPOI
            });
        }
    },[verPuntosDeReferencia])

    useEffect(() => {
        if(verCamaras){
            crearMarcadoresCamara()
        }else{
            closeModalCamara()
            hookIncidentes.stateIncidentes.googleMap.quitarMarcadorEspecifico(marcadorCamaraRef.current)
            marcadorCamaraRef.current = null
        }
    },[verCamaras])

    useEffect(() => { 
        console.log('payload → ',stateSocket.payload , ' TOPICO → ',stateSocket.payload.topic, ' topic → ', trackingTopic)
        if(Object.keys(stateSocket.payload).length > 0){
            switch(stateSocket.payload.topic){
                case "ABX/MOBILE/PLAMIN/ALERT/RQ":
                    const alertaPanico = JSON.parse(stateSocket.payload.message.bd.message)
                    const uidAlertaEntrante = stateSocket.payload.message.hd.uid;
                    alertaPanico.uidAlertaPropio = uidAlertaEntrante;
                    // console.log("uidAlertaEntrante ------>", uidAlertaEntrante)
                    if(arrayEmpresasAlertasPermitidas.includes(Number(alertaPanico.codEmpresa))){
                        alertaPanico.latitudAlerta = Number(alertaPanico.latitudAlerta)
                        alertaPanico.longitudAlerta = Number(alertaPanico.longitudAlerta)
                        showNotification({mensajeAlerta: `${alertaPanico.mensajeAlerta}`, nombreCarpeta: '', imagenAlerta: ''})
                        notify(alertaPanico.mensajeAlerta ? capitalizarTexto(alertaPanico.mensajeAlerta) + ` [${alertaPanico.fechaHoraAlerta.split(' ')[1]}]` : '¡Se envió una alerta!', 'error', { autoClose: false});
                        audioAlerta.current?.play();
                        (async () => {
                            // Cerrar cualquier infowindow abierto previamente
                            infowindowRef.current.close();
                            
                            await hookIncidentes.ubicarIncidencia(alertaPanico, true, true );
                            // await hookIncidentes.registrarAlertaPanico(alertaPanico);
                            await hookIncidentes.listarIncidentes();
                            cargarJurisdiccionYComisaria (alertaPanico.latitudAlerta, alertaPanico.longitudAlerta, uidAlertaEntrante);
                            
                            const esteMarcador = hookIncidentes.marcadorAlerta.current;
                            const datosDeEstaAlerta = { ...alertaPanico };
                            infowindowRef.current.close();
                            // Remover listeners previos
                            if(esteMarcador) {
                                google.maps.event.clearListeners(esteMarcador, 'click');
                                google.maps.event.clearListeners(esteMarcador, 'contextmenu');
                                
                                // Agregar nuevo listener
                                google.maps.event.addListener(esteMarcador, 'click', function() {
                                    const infoWindowContent = crearInfoWindowPanico(datosDeEstaAlerta)
                                    infowindowRef.current.close();
                                    infowindowRef.current.setContent(infoWindowContent);
                                    infowindowRef.current.marcador = this;
                                    infowindowRef.current.open(hookIncidentes.stateIncidentes.googleMap.map, this);
                                });

                                google.maps.event.addListener(esteMarcador, 'click', function(e) {
                                    navigator.clipboard.writeText(`${e.latLng.lat()},${e.latLng.lng()}`)
                                    notify('Coordenadas copiada en el portapapeles','success')
                                })
                            } 
                        })()
                        clearPayload();
                    }
                break;
                case `ABX/BS/PL/${codEntidad.padStart(10, "0")}/RQ`:
                    if(hookIncidentes.jurisdiccionMapa){
                        const nuevaAlerta = stateSocket.payload.message.bd
                        const pointToCheck = new google.maps.LatLng(nuevaAlerta.latitud,nuevaAlerta.longitud);
                        const estaDentroDeJurisdiccion = window.google.maps.geometry.poly.containsLocation(pointToCheck, hookIncidentes.jurisdiccionMapa);
                        if (estaDentroDeJurisdiccion){
                            showNotification(stateSocket.payload.message.bd)
                            notify(stateSocket.payload.message.bd.mensajeAlerta || '¡Se envió una alerta!', 'info', { autoClose: true });
                            hookIncidentes.listarIncidentes()                
                            hookIncidentes.ubicarIncidencia(stateSocket.payload.message.bd,true)
                            cargarJurisdiccionYComisaria (nuevaAlerta.latitudAlerta, nuevaAlerta.longitudAlerta);
                            audioAlerta.current?.play();
                            clearPayload();
                        }
                    }
                break
                default:
                    console.log('entrando a default')
                break;
            }
        }
    }, [stateSocket.payload])

    useEffect(() => {
        if (!socket) return

        const procesarCoordenadasPosteos = async (data) => {
            const hora = new Date().toLocaleTimeString();
            // console.log(`[${hora}] 📡 DATA RECIBIDA EN 'unidad':`, data);
            const datosPosteo = typeof data === 'string' ? JSON.parse(data) : data
            datosPosteo.latitud = Number(datosPosteo.latitude)
            datosPosteo.longitud = Number(datosPosteo.longitude)
            const puntoActual = new window.google.maps.LatLng(datosPosteo.latitud, datosPosteo.longitud)
            let estaDentroDeJurisdiccion = false

            if (poligonosTrackingRef.current && poligonosTrackingRef.current.length > 0) {
                estaDentroDeJurisdiccion = poligonosTrackingRef.current.some(poligono => 
                    window.google.maps.geometry.poly.containsLocation(puntoActual, poligono)
                )
            }

            if (!estaDentroDeJurisdiccion) {
                console.log(" Bus fuera de jurisdicción actual o iniciando recorrido. Consultando nueva jurisdicción...");
                cargarJurisdiccionYComisaria(datosPosteo.latitud, datosPosteo.longitud, null, true)
            }

            // Animar el marcador del bus
            hookIncidentes.stateIncidentes.googleMap.animarMarcador(
                hookIncidentes.marcadorUnidad.current, 
                datosPosteo.latitud, 
                datosPosteo.longitud, 
                4000
            )
            // Agregar nueva posición al recorrido para dibujar la línea
            setRecorridoUnidad((prevRecorrido) => {
                const nuevoRecorrido = [...prevRecorrido, { lat: datosPosteo.latitud, lng: datosPosteo.longitud }]
                // Si es el primer punto, creamos la línea
                if (nuevoRecorrido.length === 1) {
                    polilineaRecorridoRef.current = hookIncidentes.stateIncidentes.googleMap.crearPolilinea({
                        listLatLng: nuevoRecorrido,
                        color: '#084AF0',
                        strokeWeight: 3,
                        strokeOpacity: 0.8
                    })
                } else if (nuevoRecorrido.length > 1) {
                    // Si ya existe, la animamos
                    hookIncidentes.stateIncidentes.googleMap.animarPolilineaTiempoReal(
                        polilineaRecorridoRef.current,
                        nuevoRecorrido,
                        4000  // Misma duración que el marcador
                    )
                }
                return nuevoRecorrido
            })
            // Pequeña espera para asegurar que el marcador fue creado
            await new Promise(resolve => setTimeout(resolve, 100))
            // Agregar event listener al marcadorUnidad con verificación
            if (hookIncidentes.marcadorUnidad.current) {
                google.maps.event.clearListeners(hookIncidentes.marcadorUnidad.current, 'click')
                google.maps.event.clearListeners(hookIncidentes.marcadorUnidad.current, 'contextmenu')
                google.maps.event.addListener(hookIncidentes.marcadorUnidad.current, 'click', function () {
                    console.log('---- click marcador unidad (tracking)')
                    const infoWindowContent = crearInfowindowMarcadorUnidad(datosPosteo)
                    infowindowRef.current.setContent(infoWindowContent)
                    infowindowRef.current.marcador = this
                    infowindowRef.current.open(hookIncidentes.stateIncidentes.googleMap.map, this)
                })
                google.maps.event.addListener(hookIncidentes.marcadorUnidad.current, 'contextmenu', function (e) {
                    navigator.clipboard.writeText(`${e.latLng.lat()},${e.latLng.lng()}`)
                    notify('Coordenadas copiada en el portapapeles','success')
                })
            }
        }
        socket.on('unidad', procesarCoordenadasPosteos)
        return () => socket.off('unidad', procesarCoordenadasPosteos)
        
    }, [socket])

    useEffect(() => {
        if(hookIncidentes.stateIncidentes.incidentes.length > 0){
            const validar =  setInterval(async () => {
                if(!stateSocket.client.connected){
                    console.log('entro a condicional  en un intervalo')
                    const incidencias = await hookIncidentes.listarIncidenciasTemp()
                    const codigosArreglo1 = hookIncidentes.stateIncidentes.incidentes.map(obj => obj.codAlerta);
                    const codigosArreglo2 = incidencias.map(obj => obj.codAlerta);
                    const tienenMismosCodigos = codigosArreglo1.every(codigo => codigosArreglo2.includes(codigo));
                    if(!tienenMismosCodigos){
                        console.log('array a ', codigosArreglo1)
                        console.log('array b ', codigosArreglo2)
                        notify('Llegó una nueva alerta','success');
                        hookIncidentes.listarIncidentes();
                    }
                }
            }, 5000)
            
            return () => {
                clearInterval(validar)
            }
        }
    },[hookIncidentes.stateIncidentes.incidentes])

    useEffect(() => {
        if (!stateSocket.client || !trackingTopic) return;

        // 1. Suscribirse al tópico de la unidad
        stateSocket.client.subscribe(trackingTopic, (err) => {
            if (!err) {
                console.log(`Suscrito a: ${trackingTopic}`);
                // 2. Ejecutar endpoint una vez confirmada la suscripción
                // fetchDataForUnit(trackingTopic);
            }
        });

        // 3. FUNCIÓN DE LIMPIEZA (La respuesta a tu duda)
        return () => {
            stateSocket.client.unsubscribe(trackingTopic, () => {
                console.log(`Desuscrito de: ${trackingTopic}`);
            });
        };
    }, [trackingTopic, stateSocket.client]);

    useEffect(() => {
        console.log('recorridoAlertaPanico ', hookIncidentes.recorridoAlertaPanico)
        if(hookIncidentes.recorridoAlertaPanico.length > 0 ){
            let latitudFinal
            let longitudFinal 
            const latLngAlerta = hookIncidentes.recorridoAlertaPanico.map((data, i) => { 
                if(i === (hookIncidentes.recorridoAlertaPanico.length - 1)){latitudFinal = data.latitud; longitudFinal = data.longitud}
                return {lat: data.latitud, lng: data.longitud}
            });
            cargarJurisdiccionYComisaria(latitudFinal, longitudFinal, null, true)
            setRecorridoUnidad((prevRecorrido) => {
                const nuevoRecorrido = [...prevRecorrido, ...latLngAlerta]
                polilineaRecorridoRef.current = hookIncidentes.stateIncidentes.googleMap.crearPolilinea({
                    listLatLng: nuevoRecorrido,
                    color: '#084AF0',
                    strokeWeight: 3,
                    strokeOpacity: 0.8
                });

                hookIncidentes.marcadorUnidad.current.setOptions({
                    visible: true,
                    position: hookIncidentes.stateIncidentes.googleMap.crearObjLatLng(latitudFinal, longitudFinal),
                })
                
                return nuevoRecorrido
            })

            hookIncidentes.stateIncidentes.googleMap.map.setOptions({
                center: {lat: latitudFinal , lng: longitudFinal},
                zoom: 15
            })

            if (hookIncidentes.marcadorUnidad.current) {
                google.maps.event.clearListeners(hookIncidentes.marcadorUnidad.current, 'contextmenu');
                google.maps.event.addListener(hookIncidentes.marcadorUnidad.current, 'contextmenu', function (e) {
                    navigator.clipboard.writeText(`${e.latLng.lat()},${e.latLng.lng()}`)
                    notify('Coordenadas copiada en el portapapeles','success')
                });
            }
        }
    },[hookIncidentes.recorridoAlertaPanico]) 

    const validarFechaInicio = async (fechaStr) => {
        const regex = /^(\d{2})\/(\d{2})\/(\d{4}) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;
        const match = fechaStr.match(regex);

        if (!match) throw new Error("Formato incorrecto. Use: dd/mm/yyyy HH:mm:ss");

        const [, d, m, y, h, min, s] = match.map(Number);
        const fechaIngresada = new Date(y, m - 1, d, h, min, s);
        
        const ahora = new Date(); // Fecha y hora actual (ej. 17:19:58)
        const tresHorasEnMs = 3 * 60 * 60 * 1000;
        const diferenciaMs = ahora.getTime() - fechaIngresada.getTime();

        let fechaFinal;

        if (diferenciaMs > tresHorasEnMs) {
            fechaFinal = new Date(ahora.getTime() - tresHorasEnMs);
        } else {
            fechaFinal = fechaIngresada;
        }

        const pad = (n) => n.toString().padStart(2, '0');
        
        return `${pad(fechaFinal.getDate())}/${pad(fechaFinal.getMonth() + 1)}/${fechaFinal.getFullYear()} ` +
            `${pad(fechaFinal.getHours())}:${pad(fechaFinal.getMinutes())}:${pad(fechaFinal.getSeconds())}`;
    }

    const obtenerFechaActualAlerta = async () => {
        const ahora = new Date();
        
        const pad = (num) => num.toString().padStart(2, '0');

        return `${pad(ahora.getDate())}/${pad(ahora.getMonth() + 1)}/${ahora.getFullYear()} ` +
            `${pad(ahora.getHours())}:${pad(ahora.getMinutes())}:${pad(ahora.getSeconds())}`;
    };

    const crearInfoWindowPanico = (datosAlerta) => {
        const datoMensaje = datosAlerta.mensajeAlerta.split('/')
        const empresa = datoMensaje[1]
        const datosUnidad = datoMensaje[0].replaceAll('][', '] [').toString().replace(/[\[\]]/g, "")
        const dispositivo = datosUnidad.split(' ')[0]
        const padron = datosUnidad.split(' ')[1]
        const placa = datosUnidad.split(' ')[2]
        const conductor = datosUnidad.split(' ')[3]
        
        const container = document.createElement("div");
        const root = createRoot(container);
        root.render(
            <div className="p-4 min-w-[280px] bg-[#0b1727] text-white rounded-lg shadow-xl font-sans border border-red-900/30">
                <div className="flex items-center justify-center border-b border-gray-600 pb-2 mb-3">
                    <i className="fa fa-exclamation-triangle text-red-500 mr-2 text-lg animate-pulse"></i>
                    <span className="font-bold text-md tracking-wide text-red-400">Alerta</span>
                </div>
                <table className="w-full text-sm mb-3">
                    <tbody>
                        <tr key={'filaInfoAlerta3'} className="border-b border-gray-700/50">
                            <td className="py-1.5 text-gray-400 font-semibold w-[35%]">Empresa</td>
                            <td className="py-1.5 px-1 text-gray-400">:</td>
                            <td className="py-1.5 font-medium">{empresa || ''}</td>
                        </tr>
                        <tr key={'filaInfoAlerta'} className="border-b border-gray-700/50">
                            <td className="py-1.5 text-gray-400 font-semibold">Unidad</td>
                            <td className="py-1.5 px-1 text-gray-400">:</td>
                            <td className="py-1.5 font-medium flex items-center gap-1">
                                {padron && (
                                    <span className="bg-red-900/80 text-red-200 px-1.5 py-0.5 rounded text-xs font-bold border border-red-700/50">
                                        {padron}
                                    </span>
                                )}
                                <span>{placa || ''}</span>
                            </td>
                        </tr>
                        <tr key={'filaInfoAlerta2'}>
                            <td className="py-1.5 text-gray-400 font-semibold">Conductor</td>
                            <td className="py-1.5 px-1 text-gray-400">:</td>
                            <td className="py-1.5 font-medium text-gray-200">{conductor || ''}</td>
                        </tr>
                    </tbody>
                </table>
                <div className="bg-gray-800/40 rounded p-2 mb-4 border border-gray-700/50">
                    <p className="w-full text-center text-sm font-medium text-gray-200">
                        ¿Desea ver el recorrido de la unidad?
                    </p>
                </div>
                
                <div className="flex gap-x-3 justify-center">
                    <button 
                        className="bg-blue-600 hover:bg-blue-500 text-white font-semibold py-1.5 px-4 rounded shadow transition-all duration-200 flex items-center justify-center gap-2 group w-1/2"
                        onClick={async () => {
                            // if(Number(datosAlerta.codUnidad) !== 0 && Number(datosAlerta.codEmpresa) !== 0){
                                if(datosAlerta.uidAlertaPropio){ limpiarAlertasAnteriores(datosAlerta.uidAlertaPropio, infowindowRef.current.marcador); }
                                limpiarSeguimientoVehiculo() // LIMPIA Y DESUSCRIBE LA SALA ACTUAL PARA DARLE PASO A LA NUEVA UNIDAD
                                empresaUnidadRef.current = empresa
                                datosUnidadSeguimientoRef.current = {
                                    padron: padron,
                                    placa: placa,
                                    conductor: conductor
                                }
                                polilineaRecorridoRef.current = null
                                let fechaInicio = await validarFechaInicio(datosAlerta.fechaHoraAlerta)
                                let fechaFin = await obtenerFechaActualAlerta()
                                console.log('fechaInicio ',fechaInicio)
                                await hookIncidentes.stateIncidentes.googleMap.quitarTodosLasPolilineas()
                                await hookIncidentes.listarRecorridoAlertaPanico(datosAlerta.codEmpresa, fechaInicio, fechaFin, datosAlerta.codUnidad)
                                // await hookIncidentes.listarRecorridoAlertaPanico(44, fechaInicio, fechaFin, datosAlerta.codUnidad)
                                hookIncidentes.limpiarMarcadorUnidad();
                                hookIncidentes.marcadorUnidad.current = hookIncidentes.stateIncidentes.googleMap.crearUnidad({
                                    position: hookIncidentes.stateIncidentes.googleMap.crearObjLatLng(datosAlerta.latitudAlerta, datosAlerta.longitudAlerta),
                                    image: iconBus
                                })
                                hookIncidentes.marcadorUnidad.current.setOptions({
                                    visible: false,
                                    label: {
                                        text: placa || '',
                                        color: "#00008B", // Azul oscuro como el de tu imagen
                                        fontSize: "12px",
                                        fontWeight: "600",
                                        className: "marker-label",
                                        // top: "15px"
                                    },
                                })
    
                                // setTrackingTopic(`PLAMIN/44/${datosAlerta.codUnidad}/ALERT`)
                                // hookIncidentes.seguimientoVehiculo(44, datosAlerta.codUnidad)
                                if (socket && isConnected) {
                                    const codEmpresa = Number(datosAlerta.codEmpresa)
                                    const codUnidad = Number(datosAlerta.codUnidad)
                                    const codRuta = Number(datosAlerta.codRuta)
                                    const dataSuscripcion = { codEmpresa, codRuta, codUnidad }
                                    suscripcionActualRef.current = dataSuscripcion
                                    socket.emit('joinUnidad', dataSuscripcion, (respuesta) => {
                                        const hora = new Date().toLocaleDateString()
                                        console.log(`[${hora}] Respuesta joinUnidad`, respuesta, dataSuscripcion)
                                    })
                                } else {
                                    notify("Error: No hay conexion con el Socket", "e")
                                }
                                infowindowRef.current.close()
                            // }
                        }}
                    >
                        <i className="fa fa-route transform group-hover:scale-110 transition-transform"></i>
                        Sí
                    </button>
                    <button 
                        className="bg-gray-600 hover:bg-gray-500 text-white font-semibold py-1.5 px-4 rounded shadow transition-all duration-200 flex items-center justify-center gap-2 group w-1/2"
                        onClick={() => {
                            // setTrackingTopic(null)
                            setRecorridoUnidad([])
                            polilineaRecorridoRef.current = null
                            hookIncidentes.stateIncidentes.googleMap.quitarTodosLasPolilineas()
                            if (hookIncidentes.marcadorUnidad && hookIncidentes.marcadorUnidad.current) {
                                hookIncidentes.marcadorUnidad.current.setOptions({
                                    visible: false
                                })
                            }
                            infowindowRef.current.close()
                        }}
                    >
                        <i className="fa fa-times transform group-hover:scale-110 transition-transform"></i>
                        No
                    </button>
                </div>
            </div>
        );
        return container
    }

    const crearInfowindowMarcadorUnidad = (datos) => {        
        const container = document.createElement("div");
        const root = createRoot(container);
        const infoUnidad = datosUnidadSeguimientoRef.current
        root.render(
            <div className="p-4 min-w-[260px] bg-[#0b1727] text-white rounded-lg shadow-xl font-sans">
                <div className="flex items-center justify-center border-b border-gray-600 pb-2 mb-3">
                    <i className="fa fa-bus text-blue-400 mr-2 text-lg"></i>
                    <span className="font-bold text-md tracking-wide">Detalles de Unidad</span>
                </div>
                <table className="w-full text-sm mb-2">
                    <tbody>
                        <tr key={'filaUnidad0'} className="border-b border-gray-700/50">
                            <td className="py-2 text-gray-400 font-semibold w-[35%]">Empresa</td>
                            <td className="py-2 px-1 text-gray-400">:</td>
                            <td className="py-2 font-medium">{empresaUnidadRef.current}</td>
                        </tr>
                        <tr key={'filaUnidad1'} className="border-b border-gray-700/50">
                            <td className="py-2 text-gray-400 font-semibold">Unidad</td>
                            <td className="py-2 px-1 text-gray-400">:</td>
                            <td className="py-2 font-medium flex items-center gap-1">
                                {infoUnidad.padron && (
                                    <span className="bg-blue-900 text-blue-200 px-1.5 py-0.5 rounded text-xs font-bold">
                                        {infoUnidad.padron}
                                    </span>
                                )}
                                <span>{infoUnidad.placa || '-'}</span>
                            </td>
                        </tr>
                        <tr key={'filaUnidad2'}>
                            <td className="py-2 text-gray-400 font-semibold">Conductor</td>
                            <td className="py-2 px-1 text-gray-400">:</td>
                            <td className="py-2 font-medium text-gray-200">{infoUnidad.conductor || '-'}</td>
                        </tr>
                    </tbody>
                </table>
                <div className="mt-4 w-full flex justify-center">
                    <button
                        onClick={()=> {
                            // setTrackingTopic(null)
                            limpiarSeguimientoVehiculo() // LIMPIA Y DESUSCRIBE LA SALA ACTUAL PARA DARLE PASO A LA NUEVA UNIDAD
                            limpiarAlertasAnteriores()
                            if (hookIncidentes.stateIncidentes.googleMap.quitarTodosLosMarcadoresExcepto) {
                                hookIncidentes.stateIncidentes.googleMap.quitarTodosLosMarcadoresExcepto([])
                            }
                            setIncidenteActual({});
                            setVerMarcadoresCercanos(false);
                            infowindowRef.current.close()
                        }}
                        className="bg-red-600 hover:bg-red-500 text-white font-semibold py-2 px-4 rounded shadow-md transition-colors duration-200 flex items-center justify-center gap-2 group w-[90%]"
                    >
                        <span>Detener recorrido</span>
                        <i className="fa fa-stop-circle text-lg transform group-hover:scale-110 transition-transform"></i>
                    </button>
                </div>
            </div>
        );
        return container;
    }

    const showNotification = async (contentAlert) => {
        const registration = await navigator.serviceWorker?.getRegistration()       // PARECE QUE NUNCA SE EJECUTA
        if(!registration) return console.log("No hay un Service Worker Dash")
    
        registration.showNotification("¡ALERTA!", {
            body: contentAlert.mensajeAlerta || 'Incidente Reportado',
            image: `https://api.plaminoficial.com/api/Minio?nombreCarpetaFoto=${contentAlert.nombreCarpeta}&nombreFoto=${contentAlert.imagenAlerta}`,
            icon: icono,
            data: {
                customData: contentAlert.mensajeAlerta || "Alerta"
            },
        })
    }
    
    const mostrarUbicacionAgente = async (uidPosteo,centrarUbi)  => {
        if(!uidPosteo){
            return
        }
        hookIncidentes.stateIncidentes.googleMap.quitarTodosLosTramos()

        const response = await AuthFetch({
            url: urlBasePlamin + '/user/post?'  + new URLSearchParams({
                uid: uidPosteo,
            }),
        })
        const posteo = response.content

        if((posteo?.latitudUltima == 0 && posteo?.longitudUltima == 0)){
            notify('El agente no posee ubicacion registrada','error')
            hookIncidentes.stateIncidentes.googleMap.quitarTodosLosMarcadoresExcepto(hookIncidentes.marcadorAlerta.current)
            hookIncidentes.stateIncidentes.googleMap.infoWindow && hookIncidentes.stateIncidentes.googleMap.infoWindow.close()
            setVerAgenteAsignado(false)
            hookIncidentes.marcadorPolicia.current = null
            return
        }
        
        hookIncidentes.stateIncidentes.googleMap.quitarMarcadorEspecifico(hookIncidentes.marcadorPolicia.current)
        
        hookIncidentes.marcadorPolicia.current = hookIncidentes.stateIncidentes.googleMap.crearMarcador({
            animation: false,
            visible: true,
            icon: iconoPolicia,
            latLng: {lat: Number(posteo?.latitudUltima) , lng: Number(posteo?.longitudUltima)},
        });

        hookIncidentes.stateIncidentes.googleMap.crearRutaEntreMarcadores(hookIncidentes.marcadorAlerta.current,hookIncidentes.marcadorPolicia.current)

        if(centrarUbi){
            hookIncidentes.stateIncidentes.googleMap.map.setOptions({
                center: {lat: Number(posteo.latitudUltima) , lng: Number(posteo.longitudUltima)},
                zoom: 15
            })
        }
    }

    const asignarUsuarioAlerta = async (uidAsignado) => {
        const response = await AuthFetch({
            url: urlBasePlamin + '/Alerts/assignUser',
            method: 'POST',
            body: JSON.stringify({
                "codAlerta": incidenteActual.codAlerta,
                "uidAsignado": uidAsignado
            })
        })
        notify(response.content,response.isValid ? "success" : "error")
        
        const response2 = await AuthFetch({
            url: urlBasePlamin + '/Alerts/sendAgentAlert',
            method: 'POST',
            body: JSON.stringify({
                "uid": uidAsignado,
                "codAlerta": incidenteActual.codAlerta,
                "nomAlerta": incidenteActual.nomAlertaTipo
            })
        })
        notify(response2.content,response2.isValid ? "success" : "error")

        if(response2.isValid){
            setUsuarioPosteo(uidAsignado)
            mostrarUbicacionAgente(uidAsignado,true)
            setVerAgenteAsignado(true)
            await hookIncidentes.listarIncidentes()
            setVerAgentes(false)
            closeModalAgentes()
        }
    }

    const crearMarcadoresAgentes = async (codigoAlerta) => {    // OBTIENE LOS AGENTES Y DIBUJA LOS MARCADORES
        marcadoresAgentesRef.current.forEach(data => hookIncidentes.stateIncidentes.googleMap.quitarMarcadorEspecifico(data))
        const arrayAgentes = await hookIncidentes.obtenerUbicacionAgentes(codigoAlerta);       // EN CASO EXISTA UNA ALERTA SELECCIONADA MUESTRA LOS AGENTES RESPECTO A LA ALERTA
        setUbicacionesAgentes(arrayAgentes)
        const arregloMarcadores = arrayAgentes.map((data, i) => {   // CREA EL MARCADOR Y RETORNA LAS REFERENCIAS A ELLOS
            const marcadorCreado =
                hookIncidentes.stateIncidentes.googleMap.crearMarcador({
                    animation: false,
                    visible: true,
                    icon: iconoPolicia,
                    latLng: {
                        lat: Number(data.latitudUltima),
                        lng: Number(data.longitudUltima),
                    },
                });
            const infoWindow = googleMap.crearInfowindow({});
            marcadorCreado.addListener("click", () => {
                infoWindow.setContent(`
                    <div>
                        <div style="padding:5px">Nombre usuario: ${data.uid}</div>
                        <div style="padding:5px">Ultimo posteo: ${data.fechaUltimaUbicacion}</div>
                    </div>`);

                infoWindow.open({
                    anchor: marcadorCreado,
                    map: googleMap.map,
                });
            });
            return marcadorCreado
        });
        marcadoresAgentesRef.current = arregloMarcadores
    }
    
    const funcionesAlertasCercanas = {
        esPuntoCercano:  function (punto1, punto2) {
            return (
                (this.calcularDistancia(
                    punto1.latitudRegistro,
                    punto1.longitudRegistro,
                    punto2.latitudRegistro,
                    punto2.longitudRegistro
                ) < 200)
                &&
                (this.calcularDiferenciaMinutos(
                    punto1.fechaHoraAlerta,
                    punto2.fechaHoraAlerta
                ) < 20)
            )
        },
        calcularDistancia: function (lat1, lon1, lat2, lon2) {
            const R = 6371000; // Radio de la Tierra en metros
        
            // Convertir grados a radianes
            const rad = (deg) => deg * (Math.PI / 180);
        
            const dLat = rad(lat2 - lat1); // Diferencia de latitudes en radianes
            const dLon = rad(lon2 - lon1); // Diferencia de longitudes en radianes
        
            const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                      Math.cos(rad(lat1)) * Math.cos(rad(lat2)) *
                      Math.sin(dLon / 2) * Math.sin(dLon / 2);
        
            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        
            return R * c; // Distancia en metros
        },
        calcularDiferenciaMinutos: function(fecha1, fecha2) {
            // Función para convertir una fecha en formato DD/MM/YYYY HH:mm a objeto Date
            function convertirFecha(fechaStr) {
                const [dia, mes, anioHora] = fechaStr.split('/');
                const [anio, horaMinuto] = anioHora.split(' ');
                const [hora, minuto] = horaMinuto.split(':');
                
                return new Date(`${anio}-${mes}-${dia}T${hora}:${minuto}:00`);
            }
        
            const date1 = convertirFecha(fecha1);
            const date2 = convertirFecha(fecha2);
        
            // Calcular la diferencia en milisegundos
            const diferenciaMilisegundos = Math.abs(date2 - date1);
        
            // Convertir la diferencia a minutos (1 minuto = 60,000 milisegundos)
            return Math.floor(diferenciaMilisegundos / (1000 * 60));
        }
    }

    const enviarPorWhatsapp = async (incidencia) => {
        const nombreLugar = await hookIncidentes.stateIncidentes.googleMap.obtenerLugarMarcador({lat: incidencia.latitudRegistro, lng: incidencia.longitudRegistro})
        const url = `https://api.whatsapp.com/send/?text=${encodeURIComponent(incidencia.mensajeAlerta)}|${encodeURIComponent(incidencia.nomAlertaTipo)}:%0a${encodeURIComponent(incidencia.uid)}%0acel: ${encodeURIComponent(incidencia.numCelularPrincipal)}%0adireccion: ${nombreLugar}%0ahttps://maps.google.com/?q=${encodeURIComponent(incidencia.latitudRegistro)},${encodeURIComponent(incidencia.longitudRegistro)}`;
        window.open(url, "_blank");
    };

    const seleccionarAlerta = async (incidencia,indice) => {
        limpiarSeguimientoVehiculo() // LIMPIA Y DESUSCRIBE LA SALA ACTUAL PARA DARLE PASO A LA NUEVA UNIDAD
        limpiarAlertasAnteriores()
        setIncidenteActual(incidencia)
        verAgentes && crearMarcadoresAgentes(incidencia.codAlerta)
        setVerMarcadoresCercanos(false)     // PARA OCULTAR LOS MARCADORES CERCANOS CON CADA SELECCION DE ALERTA
        cargarJurisdiccionYComisaria(incidencia.latitudRegistro, incidencia.longitudRegistro);
        hookIncidentes.ubicarIncidencia(incidencia)    // UBICA LA INCIDENCIA EN EL MAPA
        setMarcadoresCercanos(  // MOSTRAR AQUI LAS INCIDENCIAS CERCANAS A ESTA INCIDENCIA
            hookIncidentes.stateIncidentes.incidentes.filter(elem => {
                if(JSON.stringify(elem) != JSON.stringify(incidencia)){
                    return funcionesAlertasCercanas.esPuntoCercano(elem, incidencia)
                }
            })
        );
        if(Number(incidencia.codEmpresa) !== 0 && Number(incidencia.codUnidad) !== 0){
            infowindowRef.current.close();
            const esteMarcador = hookIncidentes.marcadorAlerta.current;
            // Remover listeners previos
            if(esteMarcador) {
                google.maps.event.clearListeners(esteMarcador, 'click');                
                google.maps.event.clearListeners(esteMarcador, 'contextmenu');                
                // // Agregar nuevo listener
                google.maps.event.addListener(esteMarcador, 'click', function() {
                    const infoWindowContent = crearInfoWindowPanico(incidencia)
                    infowindowRef.current.close();
                    infowindowRef.current.setContent(infoWindowContent);
                    infowindowRef.current.marcador = this;
                    infowindowRef.current.open(hookIncidentes.stateIncidentes.googleMap.map, this);
                });

                google.maps.event.addListener(esteMarcador, 'contextmenu', function(e) {
                    navigator.clipboard.writeText(`${e.latLng.lat()},${e.latLng.lng()}`)
                    notify('Coordenadas copiada en el portapapeles','success')
                })
            }
        }
        hookIncidentes.stateIncidentes.googleMap.infoWindow && hookIncidentes.stateIncidentes.googleMap.infoWindow.close();
        if(incidencia.uidAsignado){
            setUsuarioPosteo(incidencia.uidAsignado);
            mostrarUbicacionAgente(incidencia.uidAsignado,true);
            setVerAgenteAsignado(true);
        }else{
            hookIncidentes.stateIncidentes.googleMap.quitarTodosLosTramos()
            setVerAgenteAsignado(false);
        }
    }

    const crearMarcadoresCamara = () => {
        const coordenadasPrueba = {lat: -11.988701729852501,lng: -77.06727178331631}
        marcadorCamaraRef.current = hookIncidentes.stateIncidentes.googleMap.crearMarcador({
            latLng: coordenadasPrueba,
            icon: {
                url: '/icono-camara.png',
                scaledSize: new google.maps.Size(30, 40), // Tamaño del marcador
                labelOrigin: {
                    x: 15,
                    y: -10
                }
            },
        })
        hookIncidentes.stateIncidentes.googleMap.enfocarMarcador(marcadorCamaraRef.current)
        marcadorCamaraRef.current.addListener('click', () => {
            openModalCamara()
        })
    }

    return(
        <>
            <ComponenteCarga variableCarga={estaCargando}></ComponenteCarga>
            <ContenedorParametros titulo="Incidentes" />
            <audio ref={audioAlerta} src={sonidoAlertaActual} />

            {/* MAPA Y BOTONERAS */}
            <div className="relative mapa-incidentes h-[50%]" >
                <MapaAlertas googleMap={hookIncidentes.stateIncidentes.googleMap} />

                <div className='absolute top-2 left-48 h-[45px] flex gap-1'>
                    {/* SOLO APARECE CUANDO AL SELECCIONAR UNA ALERTA SE DETECTA QUE TIENE ALERTAS CERCANAS */}
                    <button 
                        data-tip={verMarcadoresCercanos ? 'Ocultar alertas cercanas' : 'Ver alertas cercanas'}
                        className={`${marcadoresCercanos.length == 0 && 'hidden'} w-[45px] h-full rounded border  p-1 ${verMarcadoresCercanos ? 'bg-gray-400' : 'bg-black'}`}
                        onClick={() => setVerMarcadoresCercanos(!verMarcadoresCercanos)}
                    >
                        <img className='h-full' src={botonAlertasCercanas} />
                    </button><ReactTooltip></ReactTooltip>
                    <button 
                        data-tip={`${verAgentes ? 'Ocultar' : 'Mostrar'} agentes`}
                        className={`w-[45px] h-full rounded border bg-black p-1 ${verAgentes ? 'bg-gray-400' : 'bg-black'}`}
                        onClick={() => {
                            if(verAgentes){
                                closeModalAgentes()
                            }else{
                                crearMarcadoresAgentes(incidenteActual.codAlerta)
                                openModalAgentes()
                            }
                            setVerAgentes(!verAgentes);
                        }}
                    >
                        <img className='h-full' src={botonAgentesActivos} />
                    </button><ReactTooltip></ReactTooltip>
                    <button 
                        data-tip={`${verPuntosDeReferencia ? 'Mostrar' : 'Ocultar'} puntos de referencia`}
                        className={`w-[45px] h-full rounded border bg-black p-1 ${verPuntosDeReferencia ? 'bg-gray-400' : 'bg-black'}`}
                        onClick={() => setVerPuntosDeReferencia(!verPuntosDeReferencia)}
                    >
                        <img className='h-full' src={botonVerMapa} />
                    </button><ReactTooltip></ReactTooltip>
                    <button 
                        data-tip={`${verCamaras ? 'Ocultar' : 'Mostrar'} cámara`}
                        className={`w-[45px] h-full rounded border bg-black p-1 ${verCamaras ? 'bg-gray-400' : 'bg-black'}`}
                        onClick={() => setVerCamaras(!verCamaras)}
                    >
                        <img className='h-full' src={botonCamarasDisponibles} />
                    </button>
                </div>
            </div> 

            {/* TABLA DE ALERTAS */}
            <div className="containerScroll tabla-incidentes max-h-[40%] overflow-auto" >
                <table className="table">
                    <thead>
                        <tr>
                            <th className=" w-[15px]">N°</th>
                            <th className=" w-[15px]">TICKET</th>
                            <th className=" w-[150px]">FECHA HORA</th>
                            <th className=" w-[100px]">INCIDENCIA</th>
                            <th className=" W-[40%]">DETALLE</th>
                            <th className=" w-[150px]">DIRECCION</th>
                            <th className=" w-[150px]">USUARIO</th>
                            <th className=" w-[100px]">DNI</th>
                            <th className=" w-[100px]">CELULAR</th>
                            <th className=" w-[100px]">ASIGNADO</th>
                            <th className=" w-[15px]">FOTO</th>
                            <th className=" w-[200px]">SEGUIMIENTO</th>
                            <th className=" w-[15px]">ESTADO</th>
                            <th className=" w-[15px]"></th>
                            <th className=" w-[15px]"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            hookIncidentes.stateIncidentes.incidentes.length > 0 ?
                            hookIncidentes?.stateIncidentes?.incidentes
                            ?.sort((a,b) => {
                                if(a.fechaHoraAlerta !== '' && b.fechaHoraAlerta !== ''){
                                    const fechaA = formatearFechaHora(a?.fechaHoraAlerta);
                                    const fechaB = formatearFechaHora(b?.fechaHoraAlerta);
                                    if (!fechaA && !fechaB) return 0;
                                    if (!fechaA) return -1;
                                    if (!fechaB) return -1;
                                    return( fechaB - fechaA)
                                }
                            })
                            ?.map((incidencia, i) => {
                                return (
                                    <tr 
                                        key={i+1} 
                                        className={`${incidenteActual.codAlerta == incidencia.codAlerta ? '!bg-[#264258]' : ''}`} 
                                        onClick={() => seleccionarAlerta(incidencia,i)}
                                    >
                                        <td className="text-center">{i+1}</td>
                                        <td className="text-center">{incidencia.codAlerta}</td>
                                        <td className="text-center">{incidencia.fechaHoraAlerta}</td>
                                        <td className="text-center">{incidencia.nomAlertaTipo}</td>
                                        <td className="text-left">{incidencia.mensajeAlerta}</td>
                                        <td className="text-center">
                                            <div title={incidencia.direccion || '-'} className='max-w-[150px] whitespace-nowrap overflow-hidden text-ellipsis'>{incidencia.direccion || '-'}</div>
                                        </td>
                                        <td className="text-center">{incidencia.uid }</td>
                                        <td className="text-center">{incidencia.numeroDocumento}</td>
                                        <td className="text-center">{incidencia.numCelularPrincipal}</td>
                                        <td className="text-center">{incidencia.uidAsignado}</td>
                                        <td className="text-center">
                                            {
                                                incidencia.imagenAlerta 
                                                ?   <button 
                                                        className="fa fa-camera text-white-600 text-lg botonFoto" 
                                                        onClick={()=> verFoto(incidencia.nombreCarpetaAlerta,incidencia.imagenAlerta)}
                                                    ></button> 
                                                :   <></>
                                            }
                                        </td>
                                        <td className="text-center w-[200px]">
                                            <div className='gap-1 flex max-w-[200px] overflow-x-auto containerScrollSeguimiento'>
                                                {incidencia.cantidadAlertaAtencion > 0 
                                                    ?   Array.from({ length: incidencia.cantidadAlertaAtencion }, (_, index) => (
                                                            <button
                                                                key={index}
                                                                className='bg-blue-500 w-[25px] h-[25px] rounded text-xs hover:bg-blue-300'
                                                                onClick={() => { 
                                                                    hookSeguimientoAlertas.editarValorSeguimientoAlerta('codEstadoIntensidadAlerta', '');
                                                                    hookSeguimientoAlertas.editarValorSeguimientoAlerta('chkEstadoAlerta', false);
                                                                    hookSeguimientoAlertas.listarSeguimientoAlerta(incidencia.codAlerta);
                                                                }}
                                                            >
                                                                {index + 1}
                                                            </button>
                                                        )) 
                                                    :   <></>
                                                }
                                                {
                                                    incidencia.codEstado == 7       // ELIMINADO
                                                    ?   <></>
                                                    :   <button
                                                            className='bg-green-500 w-[25px] h-[25px] rounded text-xs hover:bg-green-300'
                                                            onClick={() => {
                                                                hookSeguimientoAlertas.editarValorSeguimientoAlerta('codEstadoIntensidadAlerta', '');
                                                                hookSeguimientoAlertas.editarValorSeguimientoAlerta('chkEstadoAlerta', false);
                                                                hookSeguimientoAlertas.listarSeguimientoAlerta(incidencia.codAlerta);
                                                            }}
                                                        >
                                                            <i className='fa fa-plus'/>
                                                        </button>
                                                }
                                            </div>
                                        </td>
                                        <td>
                                            <div className={`${incidencia.codEstado == 9 ? 'bg-orange-600' : incidencia.codEstado == 45 ? 'bg-green-600' : incidencia.codEstado == 7 ? 'bg-red-600' : 'bg-white'} text-xs rounded py-[2px] whitespace-nowrap w-[80px] text-center`}>{primeraLetraMayuscula(incidencia.nomEstado)}</div>
                                        </td> 
                                        <td >
                                            {
                                                incidenteActual.codAlerta == incidencia.codAlerta
                                                ?   <>
                                                        <button 
                                                            data-tip='Compartir ubicación' 
                                                            className="fas fa-share-alt text-green-600 text-lg" 
                                                            onClick={() => enviarPorWhatsapp(incidencia)}
                                                        ></button><ReactTooltip></ReactTooltip>
                                                    </>
                                                :   <></>
                                            }
                                        </td>
                                        <td >
                                            {
                                                incidenteActual.codAlerta == incidencia.codAlerta
                                                ?   <>
                                                        <button  
                                                            data-tip='Asignar agente' 
                                                            className="fas fa-user text-orange-500 text-lg"
                                                            onClick={ () => {
                                                                crearMarcadoresAgentes(incidenteActual.codAlerta)
                                                                setVerAgentes(true)
                                                                openModalAgentes()
                                                            }}
                                                        ></button><ReactTooltip></ReactTooltip>
                                                    </>
                                                :   <></>
                                            }
                                        </td>
                                    </tr>
                                )
                            })
                            :<tr ><td colSpan='16' className='text-center'>No hay información para mostrar con los parametros seleccionados</td></tr>
                        }
                    </tbody>
                </table>
            </div>

            {/* MODAL DE FOTO */}
            <Modal 
                isOpen={isOpenFoto} 
                closeModal={closeModalFoto}
                action={closeModalFoto} 
                title={`Foto [Ticket: ${incidenteActual.codAlerta}]`}
                textButtons = {{
                    confirm: ''
                }}
                validButton = {{
                    confirm: false,
                    denied: false
                }}        
            >
                <div className='flex-col h-[500px]'>


                <div 
                    className={`z-0 rounded w-[450px] border border-gray-700 h-[400px] relative mt-1 containerScroll overflow-y-auto overflow-x-auto flex justify-center items-center `}
                    style={{ width: '400x', height: '535px', textAlign:'center'}}
                >
                    <img 
                        src={fotoUrl} 
                        className={` rounded h-[100%] `}
                        // style={{ transform: `rotate(${rotacion}deg)` }}
                        style={{
                            // width: '100%',
                            // height: '100%',
                            transform: `rotate(${rotacion}deg) scale(${zoom})`,
                            // transform: `rotate(${rotacion}deg) scale(${zoom}) translate(${dragOffset.x}px, ${dragOffset.y}px)`,
                            position: 'relative',
                            top: `${dragOffset.y}px`,
                            left: `${dragOffset.x}px`,
                            
                            transition: 'transform 0.3s',
                            transformOrigin: 'center',

                            overflow: 'hidden' // Añadir overflow: hidden para recortar cualquier parte sobresaliente de la imagen
                        }}
                        alt="sin imagen" 
                        onMouseDown={(e) => {
                            if (e.button === 2) {
                                setRotacion(0);
                                setZoom(1);
                                setDragOffset({ x: 0, y: 0 });
                            } else {
                                setIsDragging(true);
                                setDragStart({ x: e.clientX, y: e.clientY });
                            }
                        }}
                        onMouseMove={(e) => {
                            if (isDragging) {
                                const x = e.clientX - dragStart.x + dragOffset.x;
                                const y = e.clientY - dragStart.y + dragOffset.y;
                                setDragOffset({ x, y });
                            }
                        }}
                        onMouseUp={() => {
                            setIsDragging(false);
                            setDragStart({ x: 0, y: 0 });
                        }}
                        onDoubleClick={() => {
                            setRotacion(0);
                            setZoom(1);
                            setDragOffset({ x: 0, y: 0 });
                        }} // Doble clic para restablecer la posición
                        onMouseLeave={() => {
                            setIsDragging(false);
                            setDragStart({ x: 0, y: 0 });
                        }} // Manejar el soltar el botón del mouse si se sale de la imagen
                    />
                </div>

                <div className=' text-center mt-1'>

                    
                    <button 
                        className=' right-0 ml-2 bottom-[90px] w-[28px] bg-green-800 hover:bg-green-700 text-xl rounded' 
                        // className={`flex rounded h-full w-full transform rotate-${rotacion}`}
                        
                        style={{zIndex:'100000'}}
                        onClick={() => {
                            if (zoom === 1) {
                                setZoom(1.2);
                            } else if (zoom === 1.2) {
                                setZoom(1.5);
                            }else if (zoom ===1.5){
                                setZoom(1.8);
                            }else if (zoom ===1.8){
                                setZoom(2.0);
                            }else if (zoom ===2.0){
                                setZoom(2.5);
                            }else if (zoom ===2.5){
                                setZoom(3.0);
                            } else {
                                setZoom(1);
                            }
                        }}
                        >
                        <i 
                            data-tip 
                            data-for='toolZoomFoto' 
                            className="fa fa-search-plus" 
                            />

                        <Tooltip
                            id='toolZoomFoto' 
                            >Zoom x{zoom}
                        </Tooltip>
                    </button>

                    <button 
                        className='ml-2 right-0 bottom-[60px] w-[28px] bg-green-800 hover:bg-green-700 text-xl rounded' 
                        // className={`flex rounded h-full w-full transform rotate-${rotacion}`}
                        
                        style={{zIndex:'100000'}}
                        onClick={() => setRotacion((rotacion + 90) % 360)}
                        >
                        <i 
                            data-tip 
                            data-for='toolGirarFoto' 
                            className="fa fa-retweet" 
                            />
                        <Tooltip
                            id='toolGirarFoto' 
                            >Girar
                        </Tooltip>
                    </button>

                    <button 
                        data-tip 
                        data-for='toolRedireccionarFoto' 
                        className=' right-0 bottom-0 ml-2 bg-blue-500 hover:bg-blue-700 text-xl rounded' 
                        style={{zIndex:'100000'}}
                        >
                        <a  
                            className="m-1 fa fa-share" 
                            target="_blank" 
                            href={`${fotoUrl}`} 
                            rel="noopener noreferrer" 
                            >
                        </a>
                        <Tooltip id='toolRedireccionarFoto' >Abrir Foto</Tooltip>
                    </button>

                    </div>


                </div>
            </Modal>

            {/* MODAL DE SEGUIMIENTO Y CALIFICACION */}
            <Modal 
                    isOpen={hookSeguimientoAlertas.isOpenModalSeguimiento}
                    textButtons = {{confirm: 'Guardar', denied: 'Cerrar'}}
                    validButton = {{ confirm:  hookSeguimientoAlertas.seguimientoAlerta?.chkEstadoAlerta? true : false , denied: true}}
                    action={() => {
                        hookSeguimientoAlertas.closeModalSeguimiento()
                        hookSeguimientoAlertas.finalizarAlerta()
                        hookIncidentes.listarIncidentes()
                    }}
                    closeModal={() => {
                        hookSeguimientoAlertas.closeModalSeguimiento()
                        hookIncidentes.listarIncidentes()
                    }} 
                    title={`Ticket: ${incidenteActual.codAlerta}`}
                >
                    <div className="flex items-center  flex-wrap justify-center " >
                        <div className="w-[700px] px-4 flex flex-col justify-between form-content overflow-auto containerScroll">
                            <div className="containerScroll flex flex-col justify-between w-full form-content overflow-auto	max-h-55 lg:w-[320px]">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th className='w-[5px] text-left'>N°</th>
                                            <th className='w-[130px] text-center'>FECHA</th>
                                            <th className='w-[40%] text-left'>DESCRIPCIÓN</th>
                                            <th className='w-[100px] text-center'>USUARIO</th>
                                            <th className='w-[50px] text-center'>OPCIONES</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            hookSeguimientoAlertas.seguimientoAlertas.length == 0
                                            ?   <></>
                                            :   hookSeguimientoAlertas.seguimientoAlertas.map((s,i) => {
                                                    return (
                                                        <tr key={i+1}>
                                                            <td className='text-center border border-gray-500'>{++i}</td>
                                                            <td className='text-center border border-gray-500'>{s.fechaHoraRegistro}</td>
                                                            <td className='text-left border border-gray-500'>{s.mensajeAlertaAtencion}</td>
                                                            <td className='text-center border border-gray-500'>{s.uidRegistro}</td>
                                                            <td className='w-[5px] border text-center border-gray-500'> 
                                                                {
                                                                    (i == hookSeguimientoAlertas.seguimientoAlertas.length) && (incidenteActual.codEstado != 7)
                                                                    ?   <button 
                                                                            className='px-1 py-1  rounded hover:bg-[#931E0C] ' 
                                                                            onClick={()=>hookSeguimientoAlertas.eliminarSeguimiento(s.codAlertaAtencion)}
                                                                        >
                                                                            <i className={`text-red-500 fa fa-trash-can text-[15px]`}></i>
                                                                        </button>
                                                                    :   <></>
                                                                }
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                        }
                                        {
                                            incidenteActual.codEstado == 7      // ELIMINADO
                                            ?   <></>
                                            :   <tr className='border border-gray-500 '>
                                                    <td className='border border-gray-500 text-center'>
                                                        {hookSeguimientoAlertas.seguimientoAlertas?.length + 1 }
                                                    </td>
                                                    <td colSpan={3} style={{height:'35px'}}>
                                                        <input className={`${classNameInput} `}
                                                            value={hookSeguimientoAlertas.seguimientoAlerta.mensajeAlertaAtencion} 
                                                            onChange={(e) => {hookSeguimientoAlertas.editarValorSeguimientoAlerta("mensajeAlertaAtencion", e.target.value)}}
                                                            autoFocus={true}
                                                        />
                                                    </td>
                                                    <td className='text-center'>
                                                        <button 
                                                            className='fa fa-angle-right rounded h-6 text-[18px] bg-green-500 px-3 py-1'
                                                            onClick={()=> {
                                                                hookSeguimientoAlertas.guardarSeguimientoAlerta();hookSeguimientoAlertas.editarValorSeguimientoAlerta("codAlerta", incidenteActual.codAlerta);
                                                                hookSeguimientoAlertas.editarValorSeguimientoAlerta("mensajeAlertaAtencion", "")}
                                                            }
                                                        >
                                                        </button>
                                                    </td>
                                                </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div className={`mt-[-15px] relative text-right max-w-full px-5 ${incidenteActual.codEstado == 7 ? '!hidden' : ''}`}>
                        <label className='mr-2 '>Finalizar ticket</label><label className="switch top-2">
                            <input className='' type="checkbox" checked={hookSeguimientoAlertas.seguimientoAlerta.chkEstadoAlerta} onChange={(e) => hookSeguimientoAlertas.editarValorSeguimientoAlerta("chkEstadoAlerta",e.target.checked)} />
                            <div className="slider"></div>
                        </label>
                    </div>

                    <div className='flex items-center flex-wrap justify-center relative mt-[20px]' style={{display: hookSeguimientoAlertas.seguimientoAlerta.chkEstadoAlerta ? '' : 'none'}}> 
                        <h2 className='absolute underline top-0 text-xl'>
                            <span ><i className='fas fa-star text-[#F4FF0B]'></i>Califique el ticket<i className='fas fa-star text-[#F4FF0B]'></i></span>
                        </h2>    

                        <div className='rounded flex gap-8 items-center relative justify-center mt-[30px]'>
                                <div className='m-[5px]'>
                                    <form action="" className='formularioRadio'>
                                        <div className="radio relative lg:max-w-[150px] ">
                                                {
                                                    hookCalificacionAlerta.calificaciones.map((c,i) => {
                                                        return (
                                                            <React.Fragment 
                                                                key={i+1}>
                                                                    <input 
                                                                        type='radio' name="calificacion" 
                                                                        value={c.codEstadoIntensidadAlerta} 
                                                                        defaultChecked={hookSeguimientoAlertas.seguimientoAlerta.codCalificacion === c.codEstadoIntensidadAlerta ? true : false} 
                                                                        id={c.nomEstado}
                                                                        onChange={(e) => {
                                                                            hookSeguimientoAlertas.editarValorSeguimientoAlerta("codEstadoIntensidadAlerta",e.target.value)}
                                                                        }>
                                                                    </input>
                                                                    <label 
                                                                        className='' 
                                                                        htmlFor={c.nomEstado} 
                                                                    >
                                                                            {(c.nomEstado)}
                                                                    </label>
                                                            </React.Fragment>
                                                        )
                                                    })
                                                }
                                        </div>
                                    </form>
                                </div>
                        </div>
                    </div>
            </Modal>

            {/* MODAL DE ASIGNACION */}
            <ModalAsignacion
                isOpen={isOpenModalAgentes} 
                closeModal={() => {
                    hookIncidentes.stateIncidentes.googleMap.infoWindow && hookIncidentes.stateIncidentes.googleMap.infoWindow.close()
                    hookIncidentes.stateIncidentes.googleMap.quitarTodosLosMarcadoresExcepto(hookIncidentes.marcadorAlerta.current)
                    hookIncidentes.stateIncidentes.googleMap.quitarTodosLosTramos()
                    setVerAgentes(false)    // CUANDO CIERRA EL MODAL DESHABILITA LA OPCION DE VER AGENTES
                    closeModalAgentes()
                }}
                title={`Asignar agente [Ticket: ${incidenteActual.codAlerta}]`}
                textButtons = {{
                    confirm: 'Ver agentes cercanos'
                }}
                validButton = {{ confirm: false , denied: false}}
            >
                <div className=" containerScroll tabla-incidentes lg:max-w-[320px] max-h-[300px] w-[400px] overflow-auto" >
                    <table className="table">
                        <thead>
                            <tr>
                                <th className="w-[15px]"></th>
                                <th className="w-[100px]">NOMBRE</th>
                                {
                                    incidenteActual.codAlerta
                                    ?   <th className="w-[80px]">DISTANCIA</th>
                                    :   <></>
                                }
                                <th className="w-[150px]">FECHA</th>
                                <th className="w-[15px]"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                ubicacionesAgentes?.length > 0 ?
                                ubicacionesAgentes?.map((data, i) => (
                                        <tr 
                                            key={i+1} 
                                            onClick={() => mostrarUbicacionAgente(data.uid,true)}
                                        >
                                            <td className="text-center">
                                                <i className={`fas fa-circle ${data.fechaUltimaUbicacion ? 'text-green-600' : 'text-red-600'}`}></i>
                                            </td>
                                            <td className="text-center">{data.uid}</td>
                                            {
                                                incidenteActual.codAlerta 
                                                ?   <td className="text-center whitespace-nowrap">{data.distanciaAgente || '-'} mtrs</td>
                                                :   <></>
                                            }
                                            <td className="text-center">{data.fechaUltimaUbicacion}</td>
                                            <td className="text-center">
                                                <button 
                                                    data-tip="Asignar agente"
                                                    className=" fas fa-check text-gray-500 hover:text-green-300 text-lg" 
                                                    onClick={() => asignarUsuarioAlerta((data.uid))}
                                                ></button><ReactTooltip></ReactTooltip>
                                            </td>
                                        </tr>
                                ))
                                :<tr ><td colSpan='6' className='text-center'>No hay información para mostrar con los parametros seleccionados</td></tr>
                            }
                        </tbody>
                    </table>
                </div>
            </ModalAsignacion>

            <Modal isOpen={isOpenModalCamara} closeModal={closeModalCamara} textButtons={{denied: 'Cerrar'}} validButton={{denied:true}} title={'Cámara [ABX]'}>
                <div className='w-[500px] relative'>
                    <img src={camaraSinConexion} className='w-full' alt="" />
                    <span className='absolute top-[50%] left-[50%] text-red-600 font-bold text-xl -translate-x-1/2 -translate-y-1/2'>IMAGEN NO DISPONIBLE</span>
                </div>
            </Modal>

            {/* MODAL DE DETALLE DE LA COMISARIA */}
            <Modal
                isOpen={isOpenComisariaDetalle}
                closeModal={() => { closeModalComisariaDetalle() }}
                title="Detalle de Comisaría"
                textButtons={{ confirm: '', denied: 'Cerrar' }}
                validButton={{ confirm: false, denied: true }}
                action={closeModalComisariaDetalle}
            >
                <div className="w-full max-w-[500px] px-4 py-2 flex flex-col gap-2">
                    <div className="flex flex-col gap-1">
                        <label className="text-xs font-bold text-gray-300">Nombre Comisaría</label>
                        <input className={`${classNameInput} cursor-not-allowed`} value={comisariaDetalle.nomComisaria || ''} disabled />
                    </div>

                    <div className="flex flex-col gap-1">
                        <label className="text-xs font-bold text-gray-300">Dirección</label>
                        <input className={`${classNameInput} cursor-not-allowed`} value={comisariaDetalle.direccion || ''} disabled />
                    </div>

                    <div className="flex flex-col gap-1">
                        <label className="text-xs font-bold text-gray-300">Comisario</label>
                        <input className={`${classNameInput} cursor-not-allowed`} value={comisariaDetalle.comisario || ''} disabled />
                    </div>

                    <div className="grid grid-cols-2 gap-4 mt-1">
                        <div className="flex flex-col gap-1">
                            <label className="text-xs font-bold text-gray-300">Teléfono 1</label>
                            <input className={`${classNameInput} cursor-not-allowed`} value={comisariaDetalle.telefonoFijoUno || ''} disabled />
                        </div>
                        <div className="flex flex-col gap-1">
                            <label className="text-xs font-bold text-gray-300">Teléfono 2</label>
                            <input className={`${classNameInput} cursor-not-allowed`} value={comisariaDetalle.telefonoFijoDos || ''} disabled />
                        </div>
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                        <div className="flex flex-col gap-1">
                            <label className="text-xs font-bold text-gray-300">Teléfono 3</label>
                            <input className={`${classNameInput} cursor-not-allowed`} value={comisariaDetalle.telefonoFijoTres || ''} disabled />
                        </div>
                        <div className="flex flex-col gap-1">
                            <label className="text-xs font-bold text-gray-300">Celular</label>
                            <input className={`${classNameInput} cursor-not-allowed`} value={comisariaDetalle.celular || ''} disabled />
                        </div>
                    </div>

                    <div className="p-3 rounded border border-zinc-700 bg-zinc-900/50 flex flex-col gap-2 mt-1">
                        <div className="grid grid-cols-2 gap-4">
                            <div className="flex flex-col gap-1">
                                <label className="text-xs text-gray-400">Latitud</label>
                                <input className={`${classNameInput} cursor-not-allowed`} value={comisariaDetalle.latitudComisaria || ''} disabled />
                            </div>
                            <div className="flex flex-col gap-1">
                                <label className="text-xs text-gray-400">Longitud</label>
                                <input className={`${classNameInput} cursor-not-allowed`} value={comisariaDetalle.longitudComisaria || ''} disabled />
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}